import { useCallback, useEffect, useRef } from "react";
import mqtt from "mqtt";

const MQTT_BROKER_URL = process.env.REACT_APP_MQTT_BROKER_URL;

export default function useMQTT(topics, onMessage) {
    const clientRef = useRef(null);
    const subscribedTopics = useRef(new Set());

    useEffect(() => {
        const client = mqtt.connect(MQTT_BROKER_URL, {
            username: process.env.REACT_APP_MQTT_USERNAME,
            password: process.env.REACT_APP_MQTT_PASSWORD,
            port: process.env.REACT_APP_MQTT_PORT,
            clientId: `client_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`,
            clean: false,
        });

        clientRef.current = client;

        client.on("connect", () => {
            console.log("MQTT Connected");
        });

        client.on("message", onMessage);

        return () => client?.end();
    }, []);

    const manageSubscriptions = useCallback(() => {
        if (!clientRef.current?.connected) return;

        topics.forEach((topic) => {
            if (!subscribedTopics.current.has(topic)) {
                clientRef.current.subscribe(topic, { qos: 0 }, (err) => {
                    if (!err) subscribedTopics.current.add(topic);
                });
            }
        });

        subscribedTopics.current.forEach((topic) => {
            if (!topics.includes(topic)) {
                clientRef.current.unsubscribe(topic, () => {
                    subscribedTopics.current.delete(topic);
                });
            }
        });
    }, [topics]);

    useEffect(() => {
        manageSubscriptions();
    }, [manageSubscriptions, topics]);

    return { mqttClient: clientRef.current };
}
